import React from 'react'

import { ActivityListQuery } from './ActivityList'
import CommentInput from 'modules/activity/components/CommentInput'
import { ActivityCommentsProvider } from './ActivityCommentsContext'
import ErrorBoundary from 'components/ErrorBoundary'

import useUserSignedIn from 'modules/user/useUserSignedIn'
import { useThreadRouteParams } from 'utils/hooks/useThreadRouteParams'

import { ArtboardInSidebar, ShareInSidebar } from 'modules/shares/types'

interface ActivityProps {
  share: ShareInSidebar
  artboard: ArtboardInSidebar
}

export const Activity: React.FC<ActivityProps> = ({ share, artboard }) => {
  const isSignedIn = useUserSignedIn()
  const shouldShowComments = isSignedIn && share.commentsEnabled

  const { threadIdentifier } = useThreadRouteParams()

  return (
    <>
      <ActivityCommentsProvider>
        <ErrorBoundary>
          <ActivityListQuery share={share} artboard={artboard} />
        </ErrorBoundary>
      </ActivityCommentsProvider>

      {shouldShowComments && (
        <CommentInput
          style={{
            marginTop: 'auto',
            paddingBottom: '0.5rem',
          }}
          shareIdentifier={share.identifier}
          artboardIdentifier={artboard.identifier}
          permanentArtboardShortId={artboard.permanentArtboardShortId}
          documentVersionShortId={artboard.documentVersionShortId}
          commentIdentifier={threadIdentifier}
          isSignedIn={isSignedIn}
        />
      )}
    </>
  )
}

export default Activity
